//@import dependencies
import React, { CSSProperties, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { customs } from 'app_config/globals'
import moment from 'moment'
import ModalMediaComponent from 'app_components/commons/modalMedia'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { BsPlay } from 'react-icons/bs'
import { useDispatch, useSelector } from 'react-redux'
import { chatbotChange } from 'app_events/app/actions'
//@end

//@import components
import { Accordion } from 'react-bootstrap';
//@end

// @import hooks
// @end

// @INFO Import types
import { CourseScreenSlug, ICourse } from 'app_types/campus/academic/courseTypes'
// @end

// @INFO Import services
import DurationFieldService from 'app_services/components/durationFieldService'
import CourseService from 'app_services/campus/academic/courseService'
// @end

// @INFO Import Styles
import './../buyCourseModule.scss'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import TooltipComponent from 'app_components/commons/TooltipComponent/TooltipComponent';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import { CourseSchedulingModes } from 'app_types/admin/courseScheduling/courseSchedulingModeTypes'
import { CourseSchedulingCourseType } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
import ButtonWithLogin from 'app_components/modules/ButtonWithLogin/ButtonWithLogin'
import CourseSchedulingEnrollmentService from 'app_services/admin/courseScheduling/courseSchedulingEnrollmentService'
import { CombinedReducers } from 'app_events/index'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { EnrollmentOrigin } from 'app_types/admin/courseScheduling/courseSchedulingEnrollmentTypes'
import { updateUserStoreAction } from 'app_events/auth/actions'
import Swal from 'sweetalert2'
import { useHistory } from 'react-router-dom'
import { routingService } from 'app_services/routingService'
import { useLocation } from 'react-router-dom'
import DropDownComponent from 'app_components/commons/DropDownComponent/DropDownComponent'
import ModalContactForm from 'app_components/modules/ModalContactForm/ModalContactForm'
import ButtonAddShoppingCar from 'app_components/modules/ButtonAddShoppingCar/ButtonAddShoppingCar'
import { formatPrice, getPrice } from 'app_utils/coursePrice'
import { BUY_ACTION } from 'app_types/shoppingCart/shoppingCarTypes'

// @ADD Component types
interface IBuyCourseModuleLayoutProps {
  course: ICourse | null
  className?: string
  style?: CSSProperties
  coursesToRender: ICourse[]
  setCurrentCourse: (course: ICourse) => void
}

const TOGGLE_ID = '0';
const ALLOWED_MODES_TO_BUY = [
  CourseSchedulingModes.VIRTUAL,
  CourseSchedulingModes.ON_LINE,
]

const DATE_FORMAT = 'DD/MM/YYYY'

const BuyCourseModuleLayout: React.FC<IBuyCourseModuleLayoutProps> = (props) => {

  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { course } = props
  const [activeKey, setActiveKey] = useState<string | undefined>(undefined)
  const [openModal, updateOpenModal] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const history = useHistory()
  const [openContactModal, setOpenContactModal] = useState<boolean>(false)
  const [generatingCourseFile, setGeneratingCourseFile] = useState<{
    status: 'loading' | 'error' | 'initial' | 'generated',
    file: string | null
  }>({ status: 'initial', file: null })
  const isMoocOrFree = !!course?.typeCourse && [CourseSchedulingCourseType.FREE, CourseSchedulingCourseType.MOOC].includes(course?.typeCourse)
  const isWithoutTutor = course?.withoutTutor || false
  const durationFieldService = useMemo(() => new DurationFieldService(), [])
  const courseSchedulingEnrollmentService = useMemo(() => new CourseSchedulingEnrollmentService(), [])
  const user = useSelector((state: CombinedReducers) => state.auth?.user)
  const screenNotification = useMemo(() => new ScreenNotificationsUtil(), [])
  const userIsAlreadyRegistered = useMemo(() =>
    user?.selfRegisterEnrollments?.some((enrollment) => enrollment?.courseID === course?.moodle_id),
    [user, course]
  )
  const { pathname } = useLocation()
  const isProgramSlug = pathname?.includes('/novedad') || props.course?.slug_type === CourseScreenSlug.PROGRAM
  const isOnlineAndOpenLine = useMemo(() => {
    return course?.schedulingMode?.name === CourseSchedulingModes.ON_LINE
  }, [course?.schedulingMode?.name])
  const shoppingCartEnabled = customs?.modules?.shoppingCart === 'enabled'

  const courseService: CourseService = new CourseService()

  const generateCourseFile = async (slug: string, params: any) => {
    setGeneratingCourseFile({ status: 'loading', file: null })
    const response = await courseService.generateCourseFile(slug, params)
    if (response && response.status === 'success') {
      setGeneratingCourseFile({ status: 'generated', file: response.path })
      window.open(response.path, '_blank');
    } else {
      setGeneratingCourseFile({ status: 'error', file: null })
    }
  }

  /**
   * @INFO Cerrar el modal
   */
  const handleCloseModal = () => {
    updateOpenModal(false)
  }

  /*
  * @INFO Abre el chatbot
  */
  const openChatbot = () => {
    // @ts-ignore
    // document.getElementsByTagName('IFRAME').Botmaker.contentDocument.getElementById('wc-button').click();
    dispatch(chatbotChange({
      open: true,
      page: null,
      metadata: null
    }))
  }

  const toggleInfo = () => {
    if (activeKey) {
      setActiveKey(undefined)
    } else {
      setActiveKey(TOGGLE_ID)
    }
  }

  const handleClickEnrollment = async () => {
    const dialogResponse = await screenNotification.showAskDelete({
      title: 'Inscripción',
      text: '¿Deseas inscribirte a este curso?',
      icon: 'question',
      confirmText: 'Inscribirme'
    })
    if (dialogResponse.isConfirmed) {
      if (!course?.moodle_id || !user) return
      setIsLoading(true)
      const response = await courseSchedulingEnrollmentService.insertOrUpdate({
        courseID: course?.moodle_id as string,
        documentID: user?.data?.profile?.doc_number as string,
        email: user?.data?.email as string,
        firstname: user?.data?.profile?.first_name as string,
        lastname: user?.data?.profile?.last_name as string,
        documentType: user?.data?.profile?.doc_type as string,
        user: user?.data?.username as string,
        password: user?.data?.profile?.doc_number as string,
        origin: EnrollmentOrigin.AUTOREGISTRO,
        sendEmail: true,
      })
      if (response?.status === "success") {
        const redirectConfirm = await Swal.fire({
          title: "Inscripción exitosa",
          text: "Ya puedes iniciar tu curso.",
          icon: "success",
          confirmButtonText: "Ir al curso",
        })
        if (redirectConfirm.isConfirmed) {
          history.push(routingService.getSecurePath())
        }
        const newData = {...user}
        if (newData.selfRegisterEnrollments?.length) {
          newData.selfRegisterEnrollments.push({
            courseID: course?.moodle_id,
            _id: response.enrollment._id
          })
        } else {
          newData.selfRegisterEnrollments =[{
            courseID: course?.moodle_id,
            _id: response.enrollment._id
          }]
        }
        dispatch(updateUserStoreAction(newData));
      }
      setIsLoading(false)
    }
  }

  const getPriceByCourse = (withIva: boolean = false) => {
    const price = getPrice(
      course?.priceCOP ?? 0,
      course?.discount ?? 0,
      withIva ? customs?.iva : '0',
      false,
      course?.endDiscountDate ?? undefined
    );
    const priceWithDiscount = getPrice(
      course?.priceCOP ?? 0,
      course?.discount ?? 0,
      withIva ? customs?.iva : '0',
      true,
      course?.endDiscountDate ?? undefined
    );
    return {price, priceWithDiscount}
  }

  const buyButton = () => {
    let component: React.ReactNode = null;
    const courseMode = course?.schedulingMode?.name ? course?.schedulingMode?.name : ''
    if (course?.enrollment_enabled) {
      if (isMoocOrFree) {
        component = (
          <ButtonWithLogin
            loading={isLoading}
            disabled={userIsAlreadyRegistered}
            onClick={handleClickEnrollment}
            variant='tertiary'
            registerRedirect={window.location.href}
            styleButton={{ width: '100%', marginBottom: '10px', paddingTop: '10px', paddingBottom: '10px', textTransform: 'initial', fontSize: '17px' }}
          >
            {userIsAlreadyRegistered ? 'Ya se encuentra inscrito' : 'Inscribirme'}
          </ButtonWithLogin>
        )
      } else if (course?.hasCost && ALLOWED_MODES_TO_BUY.includes(courseMode as CourseSchedulingModes)) {
        const {price, priceWithDiscount} = getPriceByCourse();
        if (!shoppingCartEnabled) {
          component = (
            <a href={`${customs.online_shop}/moodle/redirect/index/id/${course.moodle_id}`} className="course-buy" target="_blank" rel="noreferrer" style={{ fontSize: '17px' }}>
              {t("modules.buy_course.labels.buy_button")}
            </a>
          )
        } else {
          component = (
            <ButtonAddShoppingCar
              variant='primary'
              styleButton={{ border: '1px solid', width: '100%', marginBottom: '10px', paddingTop: '10px', paddingBottom: '10px', textTransform: 'initial', fontSize: '17px' }}
              itemToBuy={{
                identifier: course._id,
                programCode: course.program?.code ?? '-',
                externalId: course.moodle_id ?? '-',
                description: course.program?.name ?? '-',
                image: course?.extra_info?.coverUrl ?? '-',
                price: formatPrice(price),
                priceNumeric: price,
                startDate: moment(course?.startDate?.replace('T00:00:00.000Z', '')).format('DD/MM/YYYY'),
                modality: getLabelCourse(),
                priceWithDiscount: formatPrice(priceWithDiscount),
                priceWithDiscountNumeric: priceWithDiscount,
                numberOfPlaces: 1,
                dateOfAddition: null,
                buyAction: BUY_ACTION.FOR_MYSELF
              }}
              buyNow={true}
            >
              {t("modules.buy_course.labels.buy_button")}
            </ButtonAddShoppingCar>
          )
        }
      } else {
        component = (
          <TooltipComponent
            text={t('modules.buy_course.labels.tooltip_buy_chatbot')}
            placement='top'
          >
            <a href={`${customs?.whatsapp}`} className="course-buy" target="_blank" rel="noreferrer" style={{ fontSize: '17px' }}>
              {t("modules.buy_course.labels.buy_chatbot")}
            </a>
          </TooltipComponent>
        )
      }
    }
    return component;
  }

  const shoppingCarButton = () => {
    if (!shoppingCartEnabled) return null;
    let component: React.ReactNode = null;
    const {price, priceWithDiscount} = getPriceByCourse();
    if (course?.enrollment_enabled && props.course && price) {
      // if (course?.withoutTutor) {
        component = (
          <ButtonAddShoppingCar
            variant='clean'
            styleButton={{ border: '1px solid', width: '100%', marginBottom: '10px', paddingTop: '10px', paddingBottom: '10px', textTransform: 'initial', fontSize: '17px' }}
            itemToBuy={{
              identifier: props.course._id,
              programCode: props.course.program?.code ?? '-',
              externalId: props.course.moodle_id ?? '-',
              description: props.course.program?.name ?? '-',
              image: props.course?.extra_info?.coverUrl ?? '-',
              price: formatPrice(price),
              priceNumeric: price,
              startDate: moment(course?.startDate?.replace('T00:00:00.000Z', '')).format('DD/MM/YYYY'),
              modality: getLabelCourse(),
              priceWithDiscount: formatPrice(priceWithDiscount),
              priceWithDiscountNumeric: priceWithDiscount,
              numberOfPlaces: 1,
              dateOfAddition: null,
              buyAction: BUY_ACTION.FOR_MYSELF
            }}
          >
            Agregar a carrito
          </ButtonAddShoppingCar>
        )
      // }
    }
    return component;
  }

  const getLabelCourse = () => {
    let label = course?.schedulingMode?.name ?? '';
    if (props?.course?.quickLearning) {
      label = `${label} - Quick Learning`
    } else if (props?.course?.withoutTutor) {
      label = `${label} - Sin Tutor`
    } else if (props?.course?.typeCourse === CourseSchedulingCourseType.MOOC) {
      label = `${label} - MOOC`
    }
    return label
  }

  const dateSelectInfo = (action: 'title' | 'content', item: any) => {
    switch(action) {
      case 'title':
        if (item.withoutTutor) {
          return `Disponible para compra inmediata`
        } else {
          return item?.startDate ? `Fecha de inicio: ${moment(item?.startDate?.replace('T00:00:00.000Z', '')).format(DATE_FORMAT)}` : ''
        }
      case 'content':
        if (item.withoutTutor) {
          return `Disponible para compra inmediata`
        } else {
          return moment(item.startDate?.replace('T00:00:00.000Z', '')).format(DATE_FORMAT)
        }
      default:
        return '';
    }
  }

  return (
    <>
      {props.course && (
        <Accordion activeKey={activeKey} >
          <div
            className={`buy_course-component ${props.className ? props.className : ''}`}
            style={props.style}
          >
            <div
              className={`course-cover ${(props.course?.extra_info?.url_video && props.course?.extra_info?.platform_video) ? 'with-video' : ''}`}
              onClick={(props.course?.extra_info?.url_video && props.course?.extra_info?.platform_video) ? () => updateOpenModal(true) : undefined}
            >
              <img src={props.course?.extra_info?.coverUrl} alt={`Imagen del ${props.course?.program?.name}`} />
              <div className="cover-footer"></div>
              {props.course?.extra_info?.url_video && props.course?.extra_info?.platform_video && (
                <div
                  className='video-float'
                  onClick={() => updateOpenModal(true)}
                >
                  <div className='video-float-container'>
                    <div className='video-float-background'></div>
                    <OverlayTrigger
                      placement='right'
                      overlay={<Tooltip id={`course_video_${props.course._id}`} >Ver video</Tooltip>} >
                      <BsPlay />
                    </OverlayTrigger>
                  </div>
                </div>
              )}
            </div>
            <div className="course-body">
              {course && course?.hasCost && course?.priceCOP && !isMoocOrFree && (
                <>
                  {course?.discount && course?.endDiscountDate && moment().isSameOrBefore(moment.utc(course?.endDiscountDate).endOf('day')) ?
                    <div className="container-discount">
                      <div className="discount-value-card">
                        {`${course?.discount}% Dcto *`}
                      </div>
                      <p>
                        {formatPrice(getPriceByCourse(true).priceWithDiscount)}
                      </p>
                    </div>
                    : null}
                  <p className="field-price">
                    <div style={{ flex: 1 }}>
                      Inversión: {formatPrice(getPriceByCourse(true).price)}
                    </div>
                    <div>
                      <AiOutlineInfoCircle
                        onClick={toggleInfo}
                        color='#7C878E'
                        style={{ cursor: 'pointer', fontSize: '1.4rem' }}
                      />
                    </div>
                  </p>
                </>
              )}
              {isMoocOrFree && (
                <p className="field-price">
                  <div style={{ flex: 1 }}>
                    Inversión: Gratuito
                  </div>
                  <div>
                    <AiOutlineInfoCircle
                      onClick={toggleInfo}
                      color='#7C878E'
                      style={{ cursor: 'pointer', fontSize: '1.4rem' }}
                    />
                  </div>
                </p>
              )}
              <div className="buy_course_module--info1">
                {course && course?.startDate && !isMoocOrFree && !isWithoutTutor && (
                  <p className="field">{`Fecha de inicio: ${moment(course?.startDate.replace('T00:00:00.000Z', '')).format('DD/MM/YYYY')}`}</p>
                )}
                {course && isOnlineAndOpenLine && (
                  <p className="field">{`Horario: ${course?.schedule}`}</p>
                )}
                {course && course?.schedulingMode?.name && (
                  <p className="field">{`Modalidad: ${getLabelCourse()}`}</p>
                )}
                {course && course?.serviceInformation && (
                  <p className="field">{`Oferta: ${course?.serviceInformation}`}</p>
                )}
                {course && course?.city?.name && !isMoocOrFree && (
                  <p className="field">{`Ciudad: ${course?.city?.name}`}</p>
                )}
              </div>
              {course && !!course?.serviceValidity && !!isMoocOrFree && (
                <p className="field">{`Una vez complete la inscripción, tendrá ${durationFieldService.getDurationFormated(course.serviceValidity, 'large').toLowerCase()} para terminar el curso.`}</p>
              )}
              <Accordion.Collapse eventKey={TOGGLE_ID} >
                <div style={{ marginTop: '8px' }}>
                  {course?.discount && course?.endDiscountDate && moment().isSameOrBefore(moment(course?.endDiscountDate).endOf('day')) && !isMoocOrFree ? (
                    <span className="small">*Válido hasta <b>{moment.utc(course?.endDiscountDate).format('DD/MM/YYYY')}</b>. <br /> No es acumulable con otras promociones</span>
                  ) : null}
                  <div>
                    {isMoocOrFree ? (
                      <span className="small">Este curso es gratuito, pero si deseas obtener el certificado podrás comprarlo de acuerdo al valor indicado en la descripción del curso.</span>
                    ) : (
                      <span className="small">Estos valores corresponden a tarifas en pesos colombianos COP. Para la tarifa de su país por favor contáctese con la oficina de su ciudad.</span>
                    )}
                  </div>
                </div>
              </Accordion.Collapse>
            </div>
            <div className="course-actions">
              {!isProgramSlug && (
                <div className="buy-course-module--date-select">
                  <DropDownComponent
                    title={dateSelectInfo('title', props.course)}
                  >
                    {props.coursesToRender?.map((course) => (
                      <DropDownComponent.Item onClick={() => props.setCurrentCourse(course)}>
                        {dateSelectInfo('content', course)}
                      </DropDownComponent.Item>
                    ))}
                  </DropDownComponent>
                </div>
              )}
              {course && (
                <>
                  {['initial', 'loading'].includes(generatingCourseFile.status) ? (
                    <ButtonComponent
                      loading={generatingCourseFile.status === 'loading'}
                      disabled={generatingCourseFile.status === 'loading'}
                      onClick={() => generateCourseFile(course?._id, { slug_type: course?.slug_type })}
                      style={{width: '100%', marginBottom: '12px'}}
                      variant='clean'
                      textTransform='none'
                      fontSize='17px'
                    >
                      {t("modules.buy_course.labels.download")}
                    </ButtonComponent>
                  ) : (
                    <>
                      {generatingCourseFile.status === 'generated' && generatingCourseFile.file ? (
                        <a
                          className="course-download"
                          href={generatingCourseFile.file}
                          target="__blank"
                          rel="noopener noreferrer"
                        >
                          {t("modules.buy_course.labels.download")}
                        </a>
                      ) : (
                        <div className='alert alert-warning'>
                          Se ha presentado un error al generar el archivo por favor recarga la pagina y vuelve a intentar
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
              {shoppingCarButton()}
              {buyButton()}
              {isProgramSlug && !pathname?.includes('/novedad') && (
                <ButtonComponent
                  width='100%'
                  variant='tertiary'
                  marginBottom='12px'
                  onClick={() => setOpenContactModal(true)}
                >
                  Estoy interesado
                </ButtonComponent>
              )}


            </div>
            {props.course?.extra_info?.url_video &&
              props.course?.extra_info?.platform_video ?
              <ModalMediaComponent
                media={{
                  name: props.course.program?.name || '',
                  url: props.course?.extra_info?.url_video,
                  // @ts-ignore
                  type: props.course?.extra_info?.platform_video
                }}
                open={openModal}
                showDescription
                showName
                onClose={handleCloseModal}
              />
            : null}
          </div>
        </Accordion>
      )}
      <ModalContactForm
        open={openContactModal}
        onClose={() => setOpenContactModal(false)}
        defaultMessage={`Hola, estoy interesado en el ${course?.program?.name}.`}
      />
    </>
  )
}

export default BuyCourseModuleLayout
